import { useEffect, useState } from "react";
import { NAV_LINKS } from "./data";
import { EnquireButton } from "./EnquireButton";
import { Menu, X } from "lucide-react";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-bg/70 border-b border-line/50" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <a href="#top" data-testid="nav-logo" className="flex flex-col leading-none">
          <span className="font-serif text-xl md:text-2xl text-textMain">The Old Pub</span>
          <span className="font-mono text-[9px] uppercase tracking-ultra text-primary/80 mt-1">
            Cellar · Gym · Sauna
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.filter((l) => l.href !== "#enquire").map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.slice(1)}`}
              className="font-mono text-[11px] uppercase tracking-[0.2em] text-textMuted hover:text-primary transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <EnquireButton testId="enquire-header-btn" label="Enquire" className="px-6 py-3" />
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-textMain"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden backdrop-blur-xl bg-bg/95 border-t border-line/50 px-6 py-8 flex flex-col gap-6">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-${l.href.slice(1)}`}
              className="font-serif text-2xl text-textMain hover:text-primary transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};
